export const getSdkResultCode = (result) => {
  if (result == null || typeof result !== "object") {
    return null;
  }
  const raw = result.code ?? result.errcode ?? result.errCode;
  if (raw == null) {
    return null;
  }
  const code = Number(raw);
  return Number.isNaN(code) ? null : code;
};

export const isSdkSuccessMessage = (result) =>
  /^success$/i.test(String(result?.message || result?.msg || result || "").trim());

export const isSdkFailureResult = (result) => {
  const code = getSdkResultCode(result);
  return code != null && code !== 0;
};

export const isSdkSuccessResult = (result) =>
  getSdkResultCode(result) === 0 || isSdkSuccessMessage(result);

export const getSdkResultMessage = (result, fallbackMessage) =>
  result?.message || result?.msg || fallbackMessage;

export const isWebSocketConnectingError = (error) =>
  /still in connecting state|websocket.*connecting|invalidstateerror.*send.*websocket/i.test(
    String(error?.message || error?.msg || error || "")
  );

export const isLinkusProvider = (providerName) => providerName === "D2C_CLOUD_PBX";

export const normalizeTelephonyError = (error) => {
  if (error == null) {
    return new Error("Call failed");
  }
  if (isSdkSuccessResult(error)) {
    return null;
  }
  if (error instanceof Error) {
    if (isSdkSuccessMessage(error)) {
      return null;
    }
    return error;
  }
  if (typeof error === "string") {
    return new Error(error);
  }
  if (isSdkFailureResult(error)) {
    return new Error(getSdkResultMessage(error, "Call failed"));
  }
  const message = error?.message || error?.msg;
  if (message) {
    return new Error(String(message));
  }
  return new Error("Call failed");
};
